module.exports = __webpack_public_path__ + "static/img/supadog.f4c682c2.png";